export const colors = () => ({
  white: '#FFFFFF',
  black: '#252D2D',

  neutral: {
    DEFAULT: '#252D2D',
    '80': '#252D2D',
    '70': '#5F6D6D',
    '60': '#859494',
    '50': '#A8B3B3',
    '40': '#C8D0D0',
    '30': '#DEE3E3',
    '20': '#F4F6F6',
    '10': '#FFFFFF',
  },

  primary: {
    DEFAULT: '#005250',
    '40': '#005250',
    '30': '#00615F',
    '20': '#007A78',
    '10': '#089184',
  },

  green: {
    DEFAULT: '#339A72',
    '40': '#339A72',
    '30': '#67D695',
    '20': '#A7F2B7',
    '10': '#E2FCE3',
  },

  red: {
    DEFAULT: '#FF7973',
    '40': '#B73949',
    '30': '#FF7973',
    '20': '#FFBCAB',
    '10': '#FFEDE3',
  },

  yellow: {
    DEFAULT: '#FFF70A',
    '50': '#FFF70A',
    '40': '#FFFA70',
    '30': '#FFFB9B',
    '20': '#FFFDC3',
    '10': '#FFFEEB',
  },

  beige: {
    DEFAULT: '#F3EBE8',
    '40': '#F3EBE8',
    '30': '#F9F3F0',
    '20': '#FBF7F4',
    '10': '#FDFAF7',
  },
});
